import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import MDVIPCallToAction from '../components/MDVIPCallToAction';
import AnimatedPage from '../components/AnimatedPage';
import { 
  Heart, 
  Activity, 
  Stethoscope, 
  UserCheck, 
  Droplet,
  Scale,
  Shield,
  Microscope
} from 'lucide-react';

const TraditionalPrimaryCare = () => {
  const services = [
    {
      icon: Heart,
      title: "Preventative Care",
      description: "Annual physicals, women health screenings, pre-operative clearance exams and immunizations to keep you healthy."
    },
    {
      icon: Activity,
      title: "Chronic Disease Management",
      description: "Expert management of diabetes, hypertension, heart disease, and other chronic conditions."
    },
    {
      icon: Stethoscope,
      title: "Acute Illness Care",
      description: "Prompt treatment for infections, injuries, and sudden health concerns."
    },
    {
      icon: UserCheck,
      title: "Geriatric Services",
      description: "Specialized care for older adults, including assistance with creation of advance directives for eligible Medicare patients at no additional cost."
    },
    {
      icon: Droplet,
      title: "Behavioral Health and Pain Management",
      description: "Comprehensive mental health support and pain management solutions for improved quality of life."
    },
    {
      icon: Scale,
      title: "Weight Loss Management",
      description: "Personalized weight management programs with medical supervision and nutritional guidance."
    },
    {
      icon: Shield,
      title: "Cancer Screening",
      description: "Early detection screenings via convenient blood marker testing for eligible patients in addition to referrals for mammography colonoscopy and Skin cancer checks."
    },
    {
      icon: Microscope,
      title: "COLA Accredited Laboratory",
      description: "On-site laboratory testing with COLA accreditation. This includes utilization of advanced, CLIA-waived, moderately complex Prothrombin Time (PT) and International Normalized Ratio (INR) testing systems allowing realtime results for patients on Coumadin therapy."
    }
  ];

  return (
    <AnimatedPage className="min-h-screen bg-stone-50">
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-stone-50 via-stone-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-stone-900 mb-4">
              Traditional Primary Care
            </h1>
            <div className="h-1 w-24 bg-gradient-to-r from-amber-500 via-amber-500 to-orange-500 mx-auto mb-6"></div>
            <p className="text-lg text-stone-700">Under MDVIP Affiliation</p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-gradient-to-br from-stone-50 to-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((service, index) => {
              const Icon = service.icon;
              return (
                <Card 
                  key={service.title} 
                  className="glass-card-strong shadow-strong hover-lift card-premium group"
                >
                  <CardContent className="p-6">
                    <div className="flex flex-col items-center text-center">
                      <div className="mb-4 p-4 bg-gradient-to-br from-amber-50 to-orange-50 rounded-full">
                        <Icon className="h-8 w-8 text-amber-600" />
                      </div>
                      <h3 className="text-lg font-bold text-stone-900 mb-3">
                        {service.title}
                      </h3>
                      <p className="text-sm text-stone-600 leading-relaxed">
                        {service.description}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* COLA Certificate Section */}
      <section className="pt-8 pb-16 bg-stone-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center">
            <img
              src="https://customer-assets.emergentagent.com/job_premium-med-care/artifacts/wcvifw9r_cola%20image.png"
              alt="COLA Accredited Laboratory - Recognized for Quality and Excellence"
              className="w-64 h-auto rounded-lg shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* MDVIP CTA */}
      <MDVIPCallToAction />
    </AnimatedPage>
  );
};

export default TraditionalPrimaryCare;
